import { applyMiddleware, createStore, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from 'src/store/reducers/root.reducer';
import { getEnvVars } from 'src/utils';

export default function configureStore(preloadedState = {}) {
  const middlewares = [thunkMiddleware]; // loggerMiddleware
  const composeEnhancers = composeWithDevTools({
    trace: true,
    traceLimit: 25,
  });
  const middlewareEnhancer = composeEnhancers(applyMiddleware(...middlewares));

  const enhancers = [middlewareEnhancer];
  const composedEnhancers = compose(...enhancers);

  const store = createStore(rootReducer, preloadedState, composedEnhancers);

  if (getEnvVars().ENV !== 'prod') store.subscribe(() => console.log(store.getState()));

  return store;
}
